import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-deadlines.svg'

const DeadlinesBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Deadlines Available</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      Deadlines will be shown for any publications or providers you have assigned to your account.
      If you don&apos;t see deadlines here you&apos;re expecting, please speak to support.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default DeadlinesBlankState
